/** Top-level `event` name pushed to `dataLayer` for GTM triggers. */
export const GTMEvents = {
  DataLayerUpdate: "DATALAYERUPDATE",
} as const;

export type GTMEventName = (typeof GTMEvents)[keyof typeof GTMEvents];

/**
 * Standard `eventCategory` values for the data layer.
 * - Use `Click` for buttons and links (`WEBCLICK`).
 * - Use `PageView` / `SpaPageView` for full load vs client navigation when you emit those events manually.
 * - For lead forms, pass the form name as `eventCategory` directly in the payload instead of these constants.
 */
export const GTMSubEvents = {
  Click: "WEBCLICK",
  PageView: "PAGE VIEW",
  SpaPageView: "SPA PAGE VIEW",
} as const;

export type GTMSubEvent = (typeof GTMSubEvents)[keyof typeof GTMSubEvents];
